var _defs, _defs2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircleInfoBackgroundLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xmlSpace: "preserve",
  style: {
    enableBackground: "new 0 0 512 512"
  },
  viewBox: "0 0 512 512"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "circle-info-background-light_svg__a",
  d: "M0 0h512v512H0z"
}))), /*#__PURE__*/React.createElement("clipPath", {
  id: "circle-info-background-light_svg__b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#circle-info-background-light_svg__a",
  style: {
    overflow: "visible"
  }
})), /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#circle-info-background-light_svg__b)"
  }
}, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "circle-info-background-light_svg__c",
  width: 512,
  height: 512,
  x: 0,
  y: 0,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})))), /*#__PURE__*/React.createElement("mask", {
  id: "circle-info-background-light_svg__d",
  width: 512,
  height: 512,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M512 0H0v512h512z",
  style: {
    fill: "#fff",
    filter: "url(#circle-info-background-light_svg__c)"
  }
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mask: "url(#circle-info-background-light_svg__d)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M256 512c67.9 0 133-27 181-75s75-113.1 75-181-27-133-75-181S323.9 0 256 0 123 27 75 75 0 188.1 0 256s27 133 75 181 113.1 75 181 75m-40-176h24v-64h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24m40-208c8.5 0 16.6 3.4 22.6 9.4s9.4 14.1 9.4 22.6-3.4 16.6-9.4 22.6-14.1 9.4-22.6 9.4-16.6-3.4-22.6-9.4-9.4-14.1-9.4-22.6 3.4-16.6 9.4-22.6 14.1-9.4 22.6-9.4",
  style: {
    opacity: 0.1,
    enableBackground: "new"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M256 128c8.5 0 16.6 3.4 22.6 9.4s9.4 14.1 9.4 22.6-3.4 16.6-9.4 22.6-14.1 9.4-22.6 9.4-16.6-3.4-22.6-9.4-9.4-14.1-9.4-22.6 3.4-16.6 9.4-22.6 14.1-9.4 22.6-9.4m-64 120c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h24v-64h-24c-13.3 0-24-10.7-24-24"
})))));
export default SvgCircleInfoBackgroundLight;